import styled from 'styled-components';

const VendorBusinessAddressFormStyled = styled.form`
    display: flex;
    flex-direction: column;
    height: 100%;
`;

export { VendorBusinessAddressFormStyled };
